<template>
    <div>
       <wap-header></wap-header>

        <div class="wap-box">
<!--            <el-carousel :interval="5000" arrow="always" style="width: 7.1rem;height: 2.66rem;margin: 0.2rem auto">-->
            <el-carousel :interval="5000" arrow="always" style="width: 355px;height: 2.66rem;margin: 0.2rem auto">
            <el-carousel-item style="height: 100%;border-radius: 10px;">
                    <img src="@/assets/image/home/home-banner.png" style="width: 100%;height: 100%;object-fit: cover;">
                </el-carousel-item>
                <el-carousel-item style="height: 100%;border-radius: 10px;">
                    <img src="@/assets/image/home/home-banner3.png" style="width: 100%;height: 100%;object-fit: cover;">
                </el-carousel-item>
            </el-carousel>

            <div>
                <introduction-title ch-title="产品介绍" en-title="PRODUCT" style="padding-top: 30px"></introduction-title>
                <new-energy style="padding: 0 " title="新能源材料" :list="newEnergys" :type="1"></new-energy>
                <new-energy style="margin-top:10px;" title="腈类化合物及其衍生物" :list="nitrileCompounds" :type="2"></new-energy>
                <new-energy style="margin-top:10px;" title="基础化学品" :list="basicss" :type="3"></new-energy>
                <introduction-title ch-title="合作机会" en-title="PRODUCT" style="padding-top: 30px"></introduction-title>
                <cooperation-opportunities></cooperation-opportunities>
                <introduction-title ch-title="咨讯与动态" en-title="PRODUCT" style="padding-top: 30px"></introduction-title>
                <information></information>
            </div>

        </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    import IntroductionTitle from "@/components/wap/introductionTitle.vue";
    import NewEnergy from "@/views/home/component/wap_newEnergy.vue";
    import cooperationOpportunities from "@/views/home/component/wap_CP.vue";
    import Information from "@/views/home/component/wap_information.vue";


    export default {
        name: "homeWap",
        components:{wapHeader,wapFooter,IntroductionTitle,NewEnergy,cooperationOpportunities,Information},
        data(){
          return{
              newEnergys:[],
              nitrileCompounds:[],
              basicss:[],
          }
        },
        mounted() {
            const newEnergy =require('../../..//assets/JSONData/product/newEnergy.json');
            this.newEnergys=newEnergy;

            const nitrileCompound =require('../../..//assets/JSONData/product/nitrileCompound.json');
            this.nitrileCompounds=nitrileCompound;

            const basics =require('../../..//assets/JSONData/product/basics.json');
            this.basicss=basics;
        },
        methods:{

        }
    }
</script>

<style>
    .el-carousel__container{
        height: 100% !important;
    }
</style>
